module.exports = __webpack_public_path__ + "img/ilioupoli-form.065ac5b7.jpg";